



function sectionRendering() {

  fetch("?section_id=cart-drawer")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".cart-drawer__wrap", cart__html);
      $(".cart-drawer__wrap").replaceWith(render__html);
    });

  // header 
  fetch("?section_id=header")
    .then((res) => res.text())
    .then((data) => {
      var cart__html = $(data);
      var render__html = $(".header__cart p", cart__html);
      $(".header__cart p").replaceWith(render__html);
    });

}



$(".product__btn-atc").on("click", function (e) {
  e.preventDefault();
  formData = $(this).closest(".product__form").serialize();
  addToCart(formData)
})
  

  function addToCart(formData) {
    console.log('formData:',formData);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: formData,
      success: function (data) {
        console.log(data)
         $("body").addClass("cart-drawer-open");
         sectionRendering();
      },
      error: function (err) {
        console.log('error:',err);
      },
    });
  }


  function addToCartDrawer(event, el) {
  event.preventDefault();
  var variantId = $(el).attr("data-variant-id");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: variantId,
      quantity: 1
    },
    dataType: "json",
    success: function(response) {
      $("body").addClass("cart-drawer-open");
      sectionRendering();
    },
    error: function(err) {
      console.log("Error adding product to cart:", err);
    }
  });
}



  function removeItem(event, el) {
  event.preventDefault();
  var data_line = $(el).attr("data-line");
  console.log(data_line)
  var deleteData = {
    "line": data_line,
    "quantity": 0
  };
  console.log(data_line)
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: deleteData,
    success: function (data) {
      sectionRendering();
    }
  })
}


// remove item from cart drawer js end here



// increment quantity in cart drawer
function incrementCart(el) {
  var input = el.previousElementSibling;
  var value = parseInt(input.value);
  console.log(value)
  value = isNaN(value) ? 0 : value
  value++;
  input.value = value;
  changeQuantity(input);

}
// decrement quantity in cart drawer
function decrementCart(el) {
  var input = el.nextElementSibling;
  var value = parseInt(input.value);
  if (value > 0) {
    value = isNaN(value) ? 0 : value;
    value--;
    input.value = value;
    changeQuantity(input);
  }
}

function changeQuantity(input) {

  var quantity = $(input).val();
  var data_line = $(input).attr("data-line");
  var data = {
    "line": data_line,
    "quantity": quantity
  };
  $.ajax({
    type: "POST",
    url: "/cart/change.js",
    dataType: "json",
    data: data,
    success: function (data) {
      console.log(data);
      sectionRendering();
    },
    error: function (err) {
      console.log("Error from quantity update")
    }
  })


}
